<template>
    <div class="right-box">
        <div @click="qrcodeLogin = !qrcodeLogin" class="switch-qrcode" :class="{ 'pc-img': qrcodeLogin }">
            <template v-if="!qrcodeLogin">
                <el-image :src="QrcondImg"></el-image>
            </template>
            <template v-else>
                <el-image :src="pcImg"></el-image>
            </template>
        </div>
        <div style="text-align: center;margin-top: 16px;">
            <el-image :src="logo" style="width: 180px;height: 40px;"></el-image>
        </div>
        <!-- 验证码登录 -->
        <template v-if="qrcodeLogin">
            <div class="qr-box" style="">
                <div class="qr-title">
                    安全登录，防止被盗
                </div>
                <el-image :src="qrcode" :loading="qrcodeLoading"
                    style="width: 160px;height: 160px;margin: 16px 0;"></el-image>
                <div class="qr-tips">使用 <span class="link">品为云移动版</span> 扫描登录</div>
                <div class="qr-footer">联系售前客服 <spa class="phone"> 400-077-1908</spa>
                </div>
            </div>
        </template>
        <!-- 手机号登录 -->
        <template v-else>
            <div class="login-box">
                <div class="app-logo">
                    <el-image :src="appLogo"></el-image>
                </div>
                <el-form :model="loginForm" :rules="loginRules" ref="loginForm">
                    <template v-if="loginType">
                        <el-form-item prop="phone">
                            <el-input placeholder="请输入手机号" v-model="loginForm.phone">
                                <i slot="prefix" class="el-input__icon el-icon-my-phone"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item class="my-form-item">
                            <div style="display: flex;">
                                <el-input v-model="loginForm.code" placeholder="请输入验证码">
                                </el-input>
                                <verificationCode ref="verificationCode" @change="codeChange"></verificationCode>
                                <el-button @click="getCode" type="primary" style="margin-left: 8px">
                                    {{ tips }}
                                </el-button>
                            </div>
                        </el-form-item>
                    </template>
                    <template v-else>
                        <el-form-item prop="username">
                            <el-input class="my-rule" v-model="loginForm.username" placeholder="请输入用户名">
                                <i slot="prefix" class="el-input__icon el-icon-my-user"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item class="" prop="password">
                            <el-input class="my-rule" type="password" v-model="loginForm.password" show-password
                                placeholder="请输入密码" @keyup.enter.native="handleLogin">
                                <i slot="prefix" class="el-input__icon el-icon-my-lock"></i>
                            </el-input>
                        </el-form-item>
                    </template>
                </el-form>
                <div class="switch-box">
                    <template v-if="loginType">
                        <div>
                            <div @click="(loginType = false)" class="switch-btn text-gray">
                                密码登录
                            </div>
                            <div class="switch-btn text-gray" @click="register">
                                注册
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div style="flex-direction: column">
                            <div style="display: flex">
                                <div @click="(loginType = true)" class="switch-btn text-gray">
                                    验证码登录
                                </div>
                                <div @click="() => this.$router.push('/forgetpwd').catch(() => { })
                                    " class="switch-btn text-gray">
                                    忘记密码？
                                </div>
                            </div>
                            <div style="font-size: 14px;">
                                没有账号吗？<span style="margin: 0" class="ty-link" @click="register">注册新账号</span>
                            </div>
                        </div>
                    </template>
                </div>
                <el-button style="width: 100%; margin-bottom: 20px" type="primary" :loading="loading"
                    @click="handleLogin">{{
                        loading ? "登录中" : "登录" }}</el-button>
            </div>
        </template>
    </div>
</template>

<script>
import verificationCode from "@/components/verification-code";
import { IVerificationCode } from "@/api/public";
import { login, codeLogin, getQRCode, QRQuery, QRLogin } from "@/api/login";
import { mobile } from "@/utils/validate";
import { setAuthToken, setToken } from "@/utils/auth";
export default {
    // 组件名
    name: "Login",
    // 注册组件
    components: {
        verificationCode
    },
    // 接收父组件数据
    props: {},
    // 组件数据
    data() {
        return {
            trim: null,
            qrcodeLoading: false,
            qrcodeLogin: true,//是否验证码登录
            qrToken: '',//验证码token
            QrcondImg: require("@/assets/img/icon-QRcode.png"),
            pcImg: require("@/assets/img/icon-Pc.png"),
            logo: require("@/assets/img/yun_logo.png"),
            appLogo: require("@/assets/img/app-logo.png"),
            qrcode: require("@/assets/img/QR Code.png"),
            loginType: true, // false 账号登录 true 验证码登录
            tips: "获取验证码",
            loginForm: {
                username: "",
                password: "",
                rememberMe: false,
                code: "",
                uuid: "",
                phone: ''
            },
            loginRules: {
                username: [
                    { required: true, trigger: "blur", message: "请输入您的账号" },
                ],
                password: [
                    { required: true, trigger: "blur", message: "请输入您的密码" },
                ],
                code: [{ required: true, trigger: "change", message: "请输入验证码" }],
            },
            loading: false,
            open: false
        }
    },
    created() {
        this.QRcode()
    },
    watch: {
        qrcodeLogin(n) {
            if (n) {
                this.QRcode()
            }
        }
    },
    methods: {
        QRcode() {
            if (this.trim) {
                window.clearInterval(this.trim)
            }
            this.qrcodeLoading = true
            getQRCode().then(res => {
                console.log("🚀 ==> file: login.vue:148 ==> getQRCode ==> res:", res)
                this.qrcode = res.data.qr
                this.qrToken = res.data.token
                this.QRcodeQuery()
            }).finally(() => {
                this.qrcodeLoading = false
            })
        },
        QRcodeQuery() {
            console.log("🚀 ==> file: login.vue:172 ==> QRcodeQuery ==> QRcodeQuery")
            this.trim = window.setInterval(() => {
                QRQuery({ token: this.qrToken }).then(res => {
                    console.log("🚀 ==> file: login.vue:175 ==> QRQuery ==> res:", res)
                    // "code":0// 状态码 0 未扫描，1 已扫描，2 已确认，3 已取消，4 已过期
                    let code = res.data.code
                    if (code == 4) {
                        window.clearInterval(trim)
                    }
                    if (code == 2) {
                        this.toQRlogin()
                        window.clearInterval(this.trim)
                    }
                }).catch(() => {
                    window.clearInterval(this.trim)
                })
            }, 3000)
        },
        toQRlogin() {
            QRLogin(this.qrToken).then((res) => {
                this.loginSuccess(res)
            })
        },
        loginSuccess(res) {
            var curWwwPath = window.document.location.href;
            //获取主机地址之后的目录，如： testproject/test.html
            var pathName = window.document.location.pathname;
            var pos = curWwwPath.indexOf(pathName);
            //获取主机地址，如： http://localhost:8080
            var localhostPaht = curWwwPath.substring(0, pos);
            setAuthToken(res.data.loginUser.token)
            setToken(res.data.token)
            window.location.href = localhostPaht + '/web'
        },
        register() {
            this.$router.push({
                name: "register"
            });
        },
        codeChange(text) {
            this.tips = text;
        },
        getCode() {
            if (this.$refs.verificationCode.canGetCode) {
                if (mobile(this.loginForm.phone)) {
                    let type = "LOGIN_CODE";
                    // if (this.open == false) {
                    //     type = "REGISTER_CODE";
                    // } else {
                    //     type = "LOGIN_CODE";
                    // }
                    console.log({
                        phone: this.loginForm.phone,
                        type: type,
                    })
                    console.log(IVerificationCode)

                    // axios.get('/getCode', {
                    //     phone: this.loginForm.phone,
                    //     type: type,
                    // })
                    IVerificationCode({
                        phone: this.loginForm.phone,
                        type: type,
                    }).then((res) => {
                        this.$refs.verificationCode.start();
                    });
                } else {
                    this.$message.error("手机号码错误");
                }
            } else {
                this.$message.warning("倒计时结束后再发送");
            }
        },
        handleLogin() {
            const data = {};
            if (this.loginType) {
                data.phone = this.loginForm.phone;
                data.code = this.loginForm.code;
                codeLogin(data).then((res) => {
                    this.loginSuccess(res)
                })
            } else {
                data.password = this.loginForm.password;
                data.username = this.loginForm.username;
                login(data).then((res) => {
                    this.loginSuccess(res)
                })
            }


        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .my-rule .el-input__inner {
    height: 48px !important;
    line-height: 48px !important;
}

//锁
.el-icon-my-lock {
    background: url("~@/assets/icons/icon-lock.png") center no-repeat;
    background-size: 100%;
}

.el-icon-my-lock:before {
    content: "替";
    font-size: 16px;
    visibility: hidden;
}

.el-icon-my-lock {
    font-size: 16px;
}

.el-icon-my-lock:before {
    content: "\e611";
}

//手机
.el-icon-my-phone {
    background: url("~@/assets/icons/icon-phone.png") center no-repeat;
    background-size: 100%;
}

.el-icon-my-phone:before {
    content: "替";
    font-size: 16px;
    visibility: hidden;
}

.el-icon-my-phone {
    font-size: 16px;
}

.el-icon-my-phone:before {
    content: "\e611";
}

//用户
.el-icon-my-user {
    background: url("~@/assets/icons/icon-user.png") center no-repeat;
    background-size: 100%;
}

.el-icon-my-user:before {
    content: "替";
    font-size: 16px;
    visibility: hidden;
}

.el-icon-my-user {
    font-size: 16px;
}

.el-icon-my-user:before {
    content: "\e611";
}

//自定义icon End
//  .my-form-item  .el-form-item__content {
//     display: flex;
// }
.my-form-item {
    ::v-deep .el-form-item__content {
        display: flex;
    }
}

.switch-box {
    >div {
        display: flex;
    }

    div {
        justify-content: space-between;
        margin-bottom: 8px;
    }
}

.switch-btn:hover {
    cursor: pointer;
}

.ty-link {
    color: #3f80ff;
    margin: 0 8px;

    &:hover {
        cursor: pointer;
        text-decoration: underline;
    }
}

.text-gray {
    color: #666;
    font-size: 14px;
    line-height: 22px;
}

.login-box {
    padding: 42px 16px 0 32px;

}

.app-logo {
    text-align: center;
    margin-bottom: 32px;
}

.qr-footer {
    color: #8D9094;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    .phone {
        color: #2F3133;
        font-family: PingFang SC;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
}

.qr-tips {
    color: #999;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 31.274px;
    /* 195.46% */
    letter-spacing: 0.16px;

    .link {
        color: #3F80FF;
        font-family: PingFang SC;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 31.274px;
        letter-spacing: 0.16px;
    }
}

.qr-box {
    width: 256px;
    height: 256px;
    text-align: center;
    margin: auto;
    margin-top: 56px;
}

.qr-title {
    color: #333;
    font-family: PingFang SC;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 31.274px;
    /* 130.307% */
}

.right-box {
    border-radius: 8px;
    background: #FFF;
    position: relative;
    width: 386px;
    // height: 512px;
    height: 480px;
    .switch-qrcode {
        width: 80px;
        height: 80px;
        position: absolute;
        right: 0;
        top: 0;
        // border: 1px solid red;
        // background: #f7f7f7;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        &::before {
            content: "";
            background-color: #fff;
            width: 150%;
            height: 150%;
            left: -17px;
            top: -17px;
            z-index: 100;
            position: absolute;
            transform: rotate(-45deg) translateX(-50%);
        }
    }

    .pc-img {
        display: block;
        padding: 2px;
        text-align: right;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue